// export const BASE_URL = "http://192.168.0.20:3100/api/user";
export const BASE_URL = "https://app.tipanonymous.com/api/user";
// export const BASE_URL =
("https://f1eb-2402-e280-21c3-177-5c59-9be5-76e3-bdca.ngrok-free.app/api/user");
